export interface CreateBrainImageInput {
  name: string;
  description: string;
  imageRef: string;
  digest: string;
}

export interface UpdateBrainImageInput {
  name: string;
  description: string;
  imageRef: string;
  digest: string;
}

export interface ValidationError {
  field: "name" | "description" | "imageRef" | "digest";
  message: string;
}

export function validateCreateBrainImage(input: CreateBrainImageInput): ValidationError[] {
  const errors: ValidationError[] = [];
  if (input.name.length === 0) errors.push({ field: "name", message: "Pflichtfeld" });
  if (input.name.length > 200) errors.push({ field: "name", message: "max 200 Zeichen" });
  if (input.description.length > 2000) errors.push({ field: "description", message: "max 2000 Zeichen" });
  if (input.imageRef.length === 0) errors.push({ field: "imageRef", message: "Pflichtfeld" });
  if (input.imageRef.length > 500) errors.push({ field: "imageRef", message: "max 500 Zeichen" });
  if (input.digest.length > 200) errors.push({ field: "digest", message: "max 200 Zeichen" });
  return errors;
}

export function validateUpdateBrainImage(input: UpdateBrainImageInput): ValidationError[] {
  return validateCreateBrainImage(input);
}
